import { useAuth } from '@/auth/auth-context'
import { AccountSidebar } from '@/components/account/account-sidebar'
import Footer from '@/components/header/footer'
import { LoadingContainer } from '@/components/header/loading'
import NavLogoButton from '@/components/header/nav-logo-button'
import ProfileDropdown from '@/components/header/nav-profile-dropdown'
import { Outlet } from 'react-router-dom'

export function AccountLayout() {
  const { user, isLoading } = useAuth()

  if (isLoading) {
    return <LoadingContainer />
  }

  return (
    <div className="min-h-screen flex flex-col">
      <div className="container mx-auto py-6 px-6 flex-1 flex flex-col">
        {/* Header - consistent with HomeContainer */}
        <div className="flex items-start justify-between mb-8">
          <NavLogoButton />
          {user && (
            <div className="flex items-center justify-end">
              <ProfileDropdown user={user} />
            </div>
          )}
        </div>

        {/* Main content with sidebar */}
        <div className="flex flex-1 gap-8">
          <AccountSidebar />
          <main className="flex-1 min-w-0">
            <Outlet />
          </main>
        </div>

        <Footer />
      </div>
    </div>
  )
}
